import { WorkoutFormatterComponent } from './WorkoutFormatterComponent';

export default WorkoutFormatterComponent;
